var path = 'areas/master/views/browser-warning.html';
var html = "<div class=\"alert alert-warning alert-dismissible\" id=browser-warning ng-if=!hideWarning> <span type=button class=close data-dismiss=alert aria-label=Close ng-click=dismiss()><span aria-hidden=true>&times;</span></span> <p> We are redesigning Octopus web portal and your current browser, <strong>{{browserName}}</strong>, will not be supported in <strong>Octopus 4</strong>. If you have any questions or feedback then please share them with us <strong><a target=_blank href=https://github.com/OctopusDeploy/Issues/issues/3457>here</a></strong>. </p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/views/browser-warning.html
// module id = 8668001440339571
// module chunks = 1